import React, { useState } from "react";
import MixpanelService from "../utils/MixpanelService";
import PopupMenu from "../PopupMenu";

const MenuButton = ({
  url,
  title,
  icon,
  mixpanelEventName,
  mixpanelSource,
  isActiveHandler,
  dropdownOptions,
}) => {
  const [hovered, setHovered] = useState(false);

  // If url is provided, clicking MenuButton navigates to url
  // If dropdownOptions are provided, clicking MenuButton navigates to the first option
  const defaultOption = dropdownOptions?.[0];
  const defaultUrl = url || defaultOption?.url;
  const currentPath = window.location.pathname;

  function getIsActive() {
    if (isActiveHandler) return isActiveHandler();
    if (url) return url === currentPath;
    if (dropdownOptions) return dropdownOptions.some((option) => option.url === currentPath);
  }

  const menuButtonClass = `menu__item ${getIsActive() ? "menu__item--active" : ""}`;

  return (
    <div
      className="menu__item__wrapper"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <a
        href={defaultUrl}
        onClick={() =>
          MixpanelService.track(
            mixpanelEventName || defaultOption?.mixpanelEventName,
            mixpanelSource ? { source: mixpanelSource } : {}
          )
        }
        className={menuButtonClass}
      >
        <div className="menu__item__icon">{icon}</div>
        <div className="menu__item__title">{title}</div>
      </a>
      {dropdownOptions && (
        <PopupMenu
          title={title}
          options={dropdownOptions}
          visible={hovered}
          left="calc(50% + 26px)"
          top="0"
          width="258px"
        />
      )}
    </div>
  );
};

export default MenuButton;
